import React, {useState} from "react";
import { StyleSheet, Text, View, Button, Image,Dimensions, Alert} from "react-native";
import imgSrc from './images/separator1.png';


const Info = (props) => {



	return( 
		           
			<View style={styles.container}>
                <Text style={styles.text}>Are you ready to write your first prompt</Text>
                <Text style={styles.text}>using a new post translation feature?</Text>
				<View style={{justifyContent: 'center'}}>
                <Image source ={imgSrc} style={{width:Dimensions.get('window').width/3,height:Dimensions.get('window').height/2,resizeMode: 'stretch',justifyContent: 'center',alignSelf:'center' }}/>
                </View>
                
                  <View style={styles.buttonContainer}>

                <Button 
                color='#341ada'
                title="GO"
                style={StyleSheet.buttonStyle}
                onPress={() => {props.navigation.navigate('Main',{uid:props.navigation.state.params.uid,detail: null, language: props.navigation.state.params.language,langid: props.navigation.state.params.langid});}}
			   //onPress={() => {writeUserData(123,'Hi Hi we did it!',new Date().toString())}}
				> 
                </Button>
				</View>
                
			</View>
       
    )
}
//<Text style={styles.text3}>   You will write each post using our tool. </Text>
                
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
        backgroundColor:'#FFFFFF',
		justifyContent: "center",
	},
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'left',
        flexDirection: "column",
		justifyContent: "center",
	},
	buttonContainer:{
		width: '20%',
		alignSelf: 'center',
		marginVertical: 20,
	},

	text: {
		fontWeight: "bold",
		fontSize: 40
	},
    text2: {
		fontWeight: "bold",
		fontSize: 20,
        marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'left',
	},
    text3: {
		//fontWeight: "bold",
		padding: 10,
		fontSize: 18,
	},
    
    text4: {
		//fontWeight: "bold",
		padding: 30,
		fontSize: 18,
	},
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:270,
		paddingLeft: 270,
		paddingBottom: 30,

	  },
	  textArea: {
		height: 300,
		fontSize: 20,
		borderColor: '#341ada',
		borderWidth: 3,
		justifyContent: "flex-start"
	  }
})
export default Info